import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const productInformation = css`
  &&& {
    max-width: none;
  }
`;

export const productName = (theme: Theme) => css`
  padding: 0;
  white-space: normal;
  margin-right: 1rem;

  &:hover {
    color: ${theme.text.body};
  }

  &&& {
    margin-bottom: 0.25rem;
  }
`;

export const columns = css`
  &&& {
    margin-bottom: 0;
  }

  &&& {
    @media (max-width: ${dimensions.phoneLargeMax}) {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const skeletonColumns = css`
  ${columns};
  &&& {
    margin-bottom: 3rem;
  }
`;

export const imageColumn = css`
  &&& {
    @media (max-width: ${dimensions.phoneLargeMax}) {
      order: 1;
      width: inherit;
    }
  }
`;

export const imageColumnSkeleton = css`
  ${imageColumn};
  &&& {
    @media (max-width: ${dimensions.phoneLargeMax}) {
      width: 100%;
      min-height: 10rem;
      margin-bottom: 1rem;
    }
  }
`;

export const imageSkeleton = css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    &&& {
      min-height: 10rem;
    }
  }
`;

export const detailsColumn = css`
  &&& {
    @media (max-width: ${dimensions.phoneLargeMax}) {
      flex: 1;
      order: 2;
      width: inherit;
    }
  }
`;

export const skeletonButtonWrapper = css`
  display: flex;
  flex: 1;

  > div {
    margin-right: 0.5rem;
  }
`;

export const variantOptions = css`
  margin: 0.5rem 0;
`;

export const nameSection = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
